import React from 'react';
import { Link } from 'react-router-dom';
import { Button, List, Popup } from 'semantic-ui-react';

import { NombrePersonal as NombrePersonalDTO } from 'src/api/protocolo';
import { NombrePersonal } from 'src/componentes';

interface ItemListaProps {
    etiqueta: React.ReactNode;
    valor: React.ReactNode;
    color?: string;
}
const ItemLista: React.FunctionComponent<ItemListaProps> = props => {
    const { etiqueta, valor, color } = props;
    return (
        <List.Item>
            {etiqueta}:{' '}
            <span style={{ color }}>
                <b>{valor}</b>
            </span>
        </List.Item>
    );
};

type Props = Readonly<{
    id: number;
    nombre: string;
    sala: string;
    inscritos: number;
    capacidad: number;
    sobrecupo: number;
    profesor?: { nombre: NombrePersonalDTO };
}>;

const Curso = (props: Props) => {
    const { id, capacidad, inscritos, nombre, sala, sobrecupo, profesor } = props;

    const cupo = capacidad - inscritos;
    const desvanecer = !cupo;

    const style: React.CSSProperties = {
        backgroundColor: colorStringArgba(colorDelBloque(nombre), desvanecer ? 0.5 : 1),
        width: '8.4em',
        border: '1px solid #444',
        marginTop: '1px',
        marginBottom: '1px',
        opacity: desvanecer ? 0.7 : 1,
    };

    return (
        <Popup
            trigger={
                <Link to={`/horarios/cursos/${id}`}>
                    <Button style={style} active size='mini'>
                        {nombre}
                        <br />
                        S:{sala}&nbsp;cupo:&nbsp;{cupo}
                    </Button>
                </Link>
            }
            flowing
            closeOnEscape
            hideOnScroll
        >
            <Popup.Header>{nombre}</Popup.Header>
            <Popup.Content>
                <List>
                    <ItemLista etiqueta='Sala' valor={sala} />
                    <ItemLista
                        etiqueta='Inscritos'
                        valor={inscritos}
                        color={!cupo ? 'red' : undefined}
                    />
                    <ItemLista
                        etiqueta='Capacidad'
                        valor={capacidad}
                        color={!cupo ? 'red' : undefined}
                    />
                    <ItemLista etiqueta='Sobrecupos' valor={sobrecupo} />
                    {profesor ? (
                        <ItemLista
                            etiqueta='Profesor'
                            valor={<NombrePersonal nombre={profesor.nombre} patron='%N %P %m' />}
                        />
                    ) : (
                        <ItemLista etiqueta='Profesor' valor='No asignado' color='red' />
                    )}
                </List>
            </Popup.Content>
        </Popup>
    );
};

function colorDelBloque(bloque: string) {
    if (bloque.startsWith('M')) return '#ff0000';
    if (bloque.startsWith('L')) return '#0081b8';
    if (bloque.startsWith('H')) return '#fbfb00';
    return '#47ba00';
}

function colorStringArgba(color: string, opacidad: number) {
    const r = parseInt(color.slice(1, 3), 16);
    const g = parseInt(color.slice(3, 5), 16);
    const b = parseInt(color.slice(5, 7), 16);
    return `rgba(${r}, ${g}, ${b}, ${opacidad})`;
}

export default Curso;
export { Props as CursoProps };



// WEBPACK FOOTER //
// ./src/modulos/Alumnos/paginas/FichaDeAlumno/paginas/CambiosDeCurso/componentes/TablaDeCursos.tsx